module.exports = __webpack_public_path__ + "img/closed.bded5d00.png";